import { useEffect } from 'react';
import '../../../../styles/screens/client-visit-details/manage-users/UsersList.css';
import { useDispatch, useSelector } from 'react-redux';
import noUsers from '../../../../assets/no-users.svg';
import Loader from '../../../common-components/Loader';
import {
  getAllUsers,
  resetErrorAlert,
} from '../../../../slices/UserSlice';
import UserListTableBody from './UserListTableBody';
import { UserScreenStringLabels } from '../../../../util/Strings';
import ErrorAlert from '../../../common-components/ErrorAlert';
import ErrorMessages from '../../../../util/ErrorMessages';
import "../../../../styles/screens/client-visit-details/manage-module/EventsListTable.css";

function UsersListTable() {
  const visit = useSelector((state) => state.visits);
  const isVisitCompleted = visit.selectedVisitIsCompleted;
  const data = useSelector((state) => state.users.userData);
  const isLoading = useSelector((state) => state.users.isLoading);
  const errorMessageCode = useSelector((state) => state.users.errorCode);
  const dispatch = useDispatch();

  function getUsersData() {
    dispatch(getAllUsers(visit.selectedVisitId));
  }

  function handleCloseErrorAlert() {
    dispatch(resetErrorAlert(false));
  }

  useEffect(() => {
    getUsersData();
  }, []);

  if (isLoading) {
    return <Loader />;
  }
  if (errorMessageCode) {
    return (
      <ErrorAlert
        show={errorMessageCode}
        onClickHandle={handleCloseErrorAlert}
        title="Error"
        subTitle={ErrorMessages(errorMessageCode)}
      />
    );
  }
  if (!data || data.length === 0) {
    return <img src={noUsers} alt="no users" className="no-img" />;
  }

  // Separate data based on email
  const internalUsers = data.filter(user => user.email.toLowerCase().endsWith('pwc.com'));
  const clientUsers = data.filter(user => !user.email.toLowerCase().endsWith('pwc.com'));

  return (
  <div className="users-lists-wrapper">
    {internalUsers.length > 0 && clientUsers.length === 0 && (
      // Only internal users exist
      <section className="users-table-section">
        <h2 style={{ textAlign: 'left' }}>Internal Users</h2>
        <table className="users-list-table">
          <thead>
            <tr className="table-header">
              <th>{UserScreenStringLabels.userName}</th>
              <th>{UserScreenStringLabels.email}</th>
              <th>{UserScreenStringLabels.phone}</th>
              <th> </th> 
            </tr>
          </thead>
          <tbody>
            {internalUsers.map(user => (
              <UserListTableBody
                key={user._id || user.id}
                dataItem={user}
                isInternalUser={true}
              />
            ))}
          </tbody>
        </table>
      </section>
    )}

    {clientUsers.length > 0 && internalUsers.length === 0 && (
      // Only client users exist
      <section className="users-table-section">
        <h2 style={{ textAlign: 'left' }}>Client Users</h2>
        <table className="users-list-table">
          <thead>
            <tr className="table-header">
              <th>{UserScreenStringLabels.userName}</th>
              <th>{UserScreenStringLabels.email}</th>
              <th>{UserScreenStringLabels.phone}</th>
              <th> </th> 
            </tr>
          </thead>
          <tbody>
            {clientUsers.map(user => (
              <UserListTableBody
                key={user._id || user.id}
                dataItem={user}
                isInternalUser={false}
              />
            ))}
          </tbody>
        </table>
      </section>
    )}

    {internalUsers.length > 0 && clientUsers.length > 0 && (
      // Both internal and client users exist
      <>
        <section className="users-table-section">
          <h2 style={{ textAlign: 'left' }}>Internal Users</h2>
          <table className="users-list-table">
            <thead>
              <tr className="table-header">
                <th>{UserScreenStringLabels.userName}</th>
                <th>{UserScreenStringLabels.email}</th>
                <th>{UserScreenStringLabels.phone}</th>
                <th> </th> 
              </tr>
            </thead>
            <tbody>
              {internalUsers.map(user => (
                <UserListTableBody
                  key={user._id || user.id}
                  dataItem={user}
                  isInternalUser={true}
                />
              ))}
            </tbody>
          </table>
        </section>

        <section className="users-table-section">
          <h2 style={{ textAlign: 'left' }}>Client Users</h2>
          <table className="users-list-table">
            <thead>
              <tr className="table-header">
                <th>{UserScreenStringLabels.userName}</th>
                <th>{UserScreenStringLabels.email}</th>
                <th>{UserScreenStringLabels.phone}</th>
                <th> </th> 
              </tr>
            </thead>
            <tbody>
              {clientUsers.map(user => (
                <UserListTableBody
                  key={user._id || user.id}
                  dataItem={user}
                  isInternalUser={false}
                />
              ))}
            </tbody>
          </table>
        </section>
      </>
    )}

    {internalUsers.length === 0 && clientUsers.length === 0 && (
      <img src={noUsers} alt="No users" className="no-img" />
    )}
  </div>
);
}

export default UsersListTable;